<template>
  <div class="ion-margin-top report-component">
    <!-- START Timestamp Number item -->
    <ion-row>
      <ion-item class="ion-margin-end">
        <ion-label v-if="placeholders && placeholders[0]" position="floating">
          {{ placeholders[0] }}
        </ion-label>
        <ion-label v-else position="floating">Saisir...</ion-label>

        <ion-input
          :disabled="disabled"
          type="number"
          step="0.01"
          :value="value"
          @ionChange="onValueChange($event.target.value)"
        ></ion-input>
      </ion-item>

      <ion-item button :disabled="disabled" @click.stop="onItemClick">
        <ion-label position="floating">Heure de saisie</ion-label>
        <ion-input
          :disabled="disabled"
          :value="formatForDisplay(date)"
          readonly
          tabindex="-1"
          class="no-pointer-events"
        ></ion-input>
      </ion-item>
    </ion-row>
    <!-- END Timestamp Number item -->
  </div>
</template>

<script>
import { IonItem, IonInput, IonRow, IonLabel } from '@ionic/vue';
import { mixinReportComponentsCommon } from '@/components/driver/rentalCoupon/mixins/ReportComponentsCommon';

export default {
  name: 'TimestampNumber',

  components: {
    IonItem,
    IonInput,
    IonRow,
    IonLabel,
  },

  mixins: [mixinReportComponentsCommon],

  props: {
    title: String,
    placeholders: Array,
    value: String,
    date: String,
    selectedDay: String,
    disabled: Boolean,
  },

  emits: ['update:value', 'update:date'],

  methods: {
    onValueChange(value) {
      this.$emit('update:value', value);

      // if date not yet set, init it
      if (!this.date) {
        this.setNow('date', this.selectedDay);
      }
    },
  },
};
</script>
